// randomUUID is undefined in non-secure contexts / older browsers; fall back so tracking never throws.
export function newId(): string {
  return globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
